import { __rest } from "tslib";
import classNames from 'classnames';
import { createElement } from 'rax';
import RaxIcon from 'rax-icon';
import Image from 'rax-image';
const ImageComponent = Image;
const ICON_SIZE_MAP = {
    small: 's',
    medium: 'm',
    large: 'l',
};
const Icon = (props) => {
    const { prefix = 'mt-', uri, className, name, type, size = 'm', style } = props, others = __rest(props, ["prefix", "uri", "className", "name", "type", "size", "style"]);
    const _name = name || type;
    const iconSize = ICON_SIZE_MAP[size] || size;
    const newClassName = classNames(`${prefix}icon`, `${prefix}icon--${iconSize}`, className);
    if (uri && !_name) {
        return (<ImageComponent className={classNames(`${prefix}icon-img--${size}`, newClassName)} style={style} source={{ uri }}/>);
    }
    return <RaxIcon className={classNames(`${prefix}icon-${_name}`, newClassName)} style={style} {...others}/>;
};
Icon.displayName = 'Icon';
export default Icon;
